module.exports = "<div style=\"overflow-y:auto\">\r\n<app-header-admin></app-header-admin>\r\n<app-sidebar></app-sidebar>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/layout/layout.component.html
// module id = 1046
// module chunks = 31